import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CssFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CssFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.31 24.39h2.8v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.55c-.03-.12-.07-.24-.12-.34s0-.07 0-.07c-.06-.11-.14-.21-.22-.3l-7.55-7.5c-.08-.08-.18-.16-.29-.22s-.08 0-.08 0c-.1-.05-.21-.09-.33-.11s-9.63 0-9.63 0c-2.31 0-4.18 1.86-4.21 4.16v7.95h-2.8c-1.03 0-1.87.84-1.87 1.87v6.54c0 1.03.84 1.87 1.87 1.87Zm2.8-8.41h1.4a.49.49 0 0 1 0 .98H6.17v4.67h2.34a.49.49 0 0 1 0 .98h-2.8a.47.47 0 0 1-.47-.47v-5.69c0-.26.21-.47.47-.47zm13.09.47c0 .26-.21.47-.47.47h-2.34v1.87h2.34c.26 0 .47.21.47.47v2.8c0 .26-.21.47-.47.47h-2.8a.49.49 0 0 1 0-.98h2.34v-1.83h-2.34a.47.47 0 0 1-.47-.47v-2.8c0-.26.21-.47.47-.47h2.8c.26 0 .47.21.47.47m-5.61 0c0 .26-.21.47-.47.47h-2.34v1.87h2.34c.26 0 .47.21.47.47v2.8c0 .26-.21.47-.47.47h-2.8a.49.49 0 0 1 0-.98h2.34v-1.83h-2.34a.47.47 0 0 1-.47-.47v-2.8c0-.26.21-.47.47-.47h2.84c.26 0 .47.21.47.47s-.04 0-.04 0M9.92 6.17c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.05 2.34 2.34 2.34h5.14v14.02c0 .77-.76.97-1.4.97H11.33c-.64 0-1.4-.17-1.4-.97V24.4h11.22c1.03 0 1.87-.84 1.87-1.87v-6.54c0-1.03-.84-1.87-1.87-1.87H9.93V6.17Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8.87 23.27c0-2.25 1.71-3.91 4.05-3.91.66 0 1.38.17 1.92.51v1.88c-.49-.37-1.11-.61-1.81-.61-1.19 0-2.17.8-2.17 2.13s.98 2.13 2.17 2.13c.68 0 1.33-.24 1.81-.61v1.88c-.54.33-1.26.51-1.92.51-2.34 0-4.05-1.66-4.05-3.91M15.65 26.44v-1.88c.79.6 1.73.92 2.53.92.69 0 1.14-.24 1.14-.64 0-.29-.2-.51-.71-.65l-1.22-.35c-1.15-.33-1.8-1.01-1.8-2.1 0-1.4 1.23-2.39 2.86-2.39.93 0 1.62.2 2.32.58v1.84c-.88-.5-1.65-.71-2.25-.71s-.97.22-.97.56c0 .26.19.46.55.56l1.08.32c1.23.36 2.08 1 2.08 2.3 0 1.41-1.21 2.37-3 2.37-.97 0-1.91-.26-2.64-.74ZM21.86 26.44v-1.88c.79.6 1.73.92 2.53.92.69 0 1.14-.24 1.14-.64 0-.29-.2-.51-.71-.65l-1.22-.35c-1.15-.33-1.8-1.01-1.8-2.1 0-1.4 1.23-2.39 2.86-2.39.93 0 1.62.2 2.32.58v1.84c-.88-.5-1.65-.71-2.25-.71s-.97.22-.97.56c0 .26.19.46.55.56l1.08.32c1.23.36 2.08 1 2.08 2.3 0 1.41-1.21 2.37-3 2.37-.97 0-1.91-.26-2.64-.74Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6 27c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h12c.27 0 .52.11.71.29l8 8a.996.996 0 1 1-1.41 1.41l-7.71-7.71H6c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1s1 .45 1 1-.45 1-1 1Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26 17c-.55 0-1-.45-1-1v-3h-5c-1.65 0-3-1.35-3-3V4c0-.55.45-1 1-1s1 .45 1 1v6c0 .55.45 1 1 1h6c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1"
      })]
    })
  }));
};